// extracted by mini-css-extract-plugin
export default {"slot":"position-slot_slot__t28sm","label":"position-slot_label__9SHtG","empty":"position-slot_empty__KFRQQ"};